import axios from '../api/axiosConfig';
import { jwtDecode } from 'jwt-decode';
;

const login = async (username, password) => {
  console.log('login called: ', username, password);

  const resp = await axios.post('/login.php', { username, password });
  console.log('login response: ', resp.data);
  // if (resp.status !== 200) {
  //   throw new Error('Login failed, user or password incorrect');
  // }
  if (resp.data.success !== true) {
    throw new Error('Login failed: ' + resp.data.message);
  }
  if (!resp.data.token) {
    throw new Error('Login failed, token not received');
  }

  const { token } = resp.data;
  localStorage.setItem('token', token);

  return token;
};

const logout = () => {
  localStorage.removeItem('token');
};

const getProfile = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch (e) {
    return null;
  }
};

const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;
  try {
    const { exp } = jwtDecode(token);
    return Date.now() < exp * 1000;
  } catch (e) {
    return false;
  }
};

const authService = {
  login,
  logout,
  getProfile,
  isAuthenticated,
};

export default authService;
